import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { history } from '../store'
import { withNamespaces } from 'react-i18next'
import AppTimeHeader from '../containers/AppTimeHeader'
import { postTimeExtend } from '../actions/qrstime'

const EXTEND_KEY = 'vacway_time_extend_pending';

class ExtendTimeCallbackView extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: false }
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(this.props.location.search);
    const bleName          = urlParams.get('bleName');
    const additionalMinutes = parseInt(urlParams.get('additionalMinutes') || '0');
    const qrToken          = urlParams.get('qrToken');
    const paymentDate      = new Date(decodeURIComponent(urlParams.get('paymentDate') || ''));

    const redirectToAccess = () => history.replace(`/timeAccessView/${qrToken || ''}`);

    if (!bleName || !additionalMinutes || !qrToken) {
      redirectToAccess();
      return;
    }

    // Validate payment was made today
    const now = new Date();
    const isToday = paymentDate.getFullYear() === now.getFullYear()
      && paymentDate.getMonth()  === now.getMonth()
      && paymentDate.getDate()   === now.getDate();

    if (!isToday) {
      this.setState({ error: true });
      return;
    }

    // Restore pending state saved before Redsys redirect
    const pendingState = (() => {
      try { return JSON.parse(sessionStorage.getItem(EXTEND_KEY)); } catch { return null; }
    })();

    this.props.postTimeExtend({ bleName, additionalMinutes, qrToken })
      .then((answer) => {
        sessionStorage.removeItem(EXTEND_KEY);

        if (!answer.response) {
          redirectToAccess();
          return;
        }

        const newRentedTime = answer.response.newRentedTime;

        if (!pendingState) {
          // No state to restore — go to access view so user can re-authenticate
          redirectToAccess();
          return;
        }

        const prevRemaining = pendingState.timeRemainingMinutes || 0;

        history.replace(`/timeOpenView/${qrToken}`, {
          lockerData:   pendingState.lockerData,
          machineData:  pendingState.machineData,
          timeConfig:   pendingState.timeConfig,
          pricing:      pendingState.pricing,
          phoneNumber:  pendingState.phoneNumber,
          accessCode:   pendingState.accessCode,
          qrToken:      pendingState.qrToken,
          rentalData: {
            ...(pendingState.rentalData || {}),
            rentedMinutes: newRentedTime,
          },
          timeRemainingMinutes: prevRemaining + additionalMinutes,
        });
      })
      .catch(() => {
        sessionStorage.removeItem(EXTEND_KEY);
        redirectToAccess();
      });
  }

  render() {
    const { t } = this.props;
    const { error } = this.state;

    return (
      <div className="timeBackground">
        <AppTimeHeader />
        <div className="time-page-wrap">
          <div className="time-content time-center" style={{ paddingTop: 60, textAlign: 'center' }}>
            {error ? (
              <p style={{ color: '#c0392b' }}>{t('Pago no válido. Por favor, inténtalo de nuevo.')}</p>
            ) : (
              <div>
                <div className="spinner-border text-primary" role="status" style={{ width: 48, height: 48 }} />
                <p style={{ marginTop: 16, color: '#666' }}>{t('Procesando tu pago...')}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  qrData: state.qrs.qr,
})

const mapDispatchToProps = dispatch => ({
  postTimeExtend: bindActionCreators(postTimeExtend, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(ExtendTimeCallbackView))
